<template>
    <router-view/>
    <el-dialog
      custom-class="verification_dialog"
      v-model="verificationDialogVisible"
      modal="true"
      width="80%"
      center
      :before-close="handleClose"
      :show-close="false"
    >
      <div class="_title">验证通过后可查看完整内容</div>
      <div class="_content">
        <div class="_content_title">{{ role }}</div>
        <!-- <div>1</div>
          <div>1</div>
              @focus="onOneFouce($event, index)"
          <div>1</div>
          <div>1</div> -->
          <!-- 手机号验证码 -->
          <div class="validate_wrapper" v-if="loginVerRules =='4'">

            <div class="phone_num">
              <span>
                {{patientPhoneEncode}}
              </span>
            </div>
            <!-- 获取验证码 -->
            <div class="validate_btn_wrapper">
              <!-- 验证码 -->
              <el-input v-model="messageRulesValue" type="number"/>
              <div class="validate_border"></div>
              <div class="validate_txt">
                <el-button link @click="getVerificationCode" :disabled="countdown > 0">
                  {{ countdown > 0 ? `${countdown}s` : '点击获取' }}
                </el-button>
              </div>
              <!-- 获取验证码按钮 -->
            </div>
          </div>
          <!-- 非验证码 -->
          <div v-else class="fill-message">
            <div v-for="(item, index) in captchas" :key="index">
              <input
                :class="{'ac':item.num!=''}"
                v-model="item.num"
                :id="'captcha' + index"
                @input="onOneInput($event, index)"
                @keyup.delete="deleteOneInput($event, index)"
                class="captcha_input_box row-center"
                autofocus
                autocomplete="off"
                maxlength="1"
              />
            </div>
          </div>
      </div>
      <div class="_zhuShi">注：部分未实名认证体检患者无法使用此功能，请谅解</div>
      <div class="_footer" :class="{' _footer_ac':codesLength >= 4}" @click="handleLoginVerRules">确认</div>
    </el-dialog>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  data(){
    return {
      role: "",
      loginVerRules:'1',
      messageRulesValue:'', //手机短信验证码
      countdown: 0, // 倒计时
      captchas: [{ num: "" }, { num: "" }, { num: "" }, { num: "" }], // 验证码
      codesLength:0, // 验证码长度
  }
  },
  watch:{
    messageRulesValue(newVal, oldVal) {
      let arr = [];
      for(let i= 0; i< newVal.length; i++){
        arr.push({
          num:newVal[i]
        })
      }
      this.captchas = arr
      this.codesLength = this.captchas.length
    },
  },
  computed: {
    ...mapGetters(['verificationDialogVisible']),
    patientPhoneEncode(){
      function patientPhoneEncode(phoneNumber){

        if (phoneNumber == null) {
            return phoneNumber; // 如果号码为空或长度不足，直接返回原号码
        }
        // 假设手机号码是11位，例如中国的手机号码
        // 如果手机号码长度不同，可以相应地调整索引
        let prefix = phoneNumber.substring(0, 3); // 前三位
        let suffix = phoneNumber.substring(7); // 后四位（包括可能的"-"或空格等）
        let obfuscated = prefix + "****" + suffix; // 隐藏中间四位
        return obfuscated;
      }
      return patientPhoneEncode(this.patientPhone)
    }
  },
  created(){
       // 获取医院配置
    this.$store
      .dispatch("getDispConfig")
      .then((res) => {
        const {loginVerRules} =  res.result
        const role = {
          '1':'请输入当前患者申请单号后四位',
          '2':'请输入当前患者手机号后四位',
          '3':'请输入当前患者身份证号后四位',
          '4':'请输入当前患者手机号及验证码',
          '5':'请输入当前患者身份证号或手机号后四位',
        }
        this.role = role[loginVerRules]
        this.loginVerRules = loginVerRules

        // 短信验证码进入
        if(loginVerRules == '4'){
          // 获取手机号
          this.$store.dispatch('getPatientPhone')

        }
        // 更新验证规则的弹窗
        this.$store.dispatch("verificationDialogVisible",!!loginVerRules)
      })
      .catch(() => {})
  },
   mounted: function() {
    let _this = this;
    // 最后一次键盘鼠标操作的时间
    var lastOperateTime = new Date();
    // 启动屏保时间，默认 30 分钟
    var SCREENSAVER_TIME =  30 * 60 * 1000;
    // 当用户执行键盘、鼠标操作后，执行的函数
    function afterOperate() {
      console.log("进入加监听浏览器激活状态");
      var thisOperateTime = (lastOperateTime = new Date());
      setTimeout(function() {
        if (thisOperateTime === lastOperateTime) {
          // 启动屏保
          console.log("启动屏保");
          _this.$store.dispatch("verificationDialogVisible",true);
          _this.captchas = [{ num: "" }, { num: "" }, { num: "" }, { num: "" }];
          //
        } else {
          console.log("此后，用户又进行了操作，所以不启动屏保");
          // 此后，用户又进行了操作，所以不启动屏保
        }
      }, SCREENSAVER_TIME);
    }
    afterOperate();
    // 注册事件
    document.onmousedown = afterOperate;
    document.onscroll = afterOperate;
    document.onkeypress = afterOperate;
   },
   methods:{
     // 点击确认
    handleLoginVerRules(){
      if(this.codesLength >= 4){
      this.$store
      .dispatch("loginCheck",{
        "loginVerRules":this.loginVerRules,
        "loginVerRulesValue": this.captchas.map((x) => x.num).join(""),
      })
      .then((res) => {
        const {result, msg} = res;
        if(!result){
          ElMessage({
            message:  msg,
            type: "warning"
          })
        }else{
          // 状态管理是否需要验证
          this.$store.dispatch("verificationDialogVisible",false)
          this.$store.dispatch("verificationOnce",true)
        }
      })
      .catch(() => {})
      }else{
        // console.log(this)
        // ElMessage({
        //   message: "请填写",
        //   type: "warning"
        // })
      }
    },
    handleClose(done) {
      console.log(123)
      // done()
    },
    getVerificationCode(form) {
      this.startCountdown()
      this.$store.dispatch("sendVerification",{
                "ptPhone":this.patientPhone
            }).then()
    },
    startCountdown() {
      if (this.countdown > 0) return;
      this.countdown = 60; // 假设验证码有效期为60秒
      const intervalId = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown -= 1;
        } else {
          this.countdown = 0;
          clearInterval(intervalId);
        }
      }, 1000);
    },
    // 自动校准输入顺序
    onOneFouce(e, index) {
      const str = Object.values(this.captchas)
        .map((item) => item.num)
        .join("")
      const dom = document.getElementById("captcha" + str.length)
      if (dom) dom.focus()
    },
    // 输入
    onOneInput(e, index) {
      const value = e.target.value.slice(0, 1)
      let dom = document.getElementById("captcha" + index)
      // let regExp = /^\||\d+$/
      // if (!regExp.test(value)) {
      //   return (dom.value = "")
      // }
      dom.value = value
      this.captchas[index].num = value
      let code = this.captchas.map((x) => x.num).join("")
      this.codesLength = code.length
      if (index + 1 >= this.captchas.length) return
      if (!this.captchas[index].num) return
      let domN = document.getElementById("captcha" + (index + 1))
      domN.focus()
    },
     // 删除
    deleteOneInput(e, index) {
      if (index <= 0) return
      this.captchas[index].num = ""
      let code = this.captchas.map((x) => x.num).join("");
      this.codesLength = code.length;
      let dom = document.getElementById("captcha" + (index - 1))
      dom.focus()
    },
   }
}
</script>

<style lang="scss" scope>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

.verification_dialog {
  height: 100%;
  width: 100% !important;
  margin: 0;
  background-color: rgba(240, 241, 242, 0.8);
  padding-top: 85px;
  border-radius: 0;
  // backdrop-filter: blur(6px);
  // backdrop-filter:blur(50px);
  // filter: blur(2px);
  ._title {
    color: #343a40;
    font-size: 20px;
    text-align: center;
    font-weight: 600;
  }
  ._content {
    flex: 1;
    margin-top: 85px;
    ._content_title {
      color: #343a40;
      font-weight: 600;
      font-size: 16px;
      text-align: left;
    }
    .fill-message {
      display: flex;
      justify-content: space-between;
      margin-top: 44px;
      div {
        // border: 1px solid #10a38b;
        text-align: center;
        line-height: 64px;
        font-size: 24px;
        font-weight: 600;

        // width: 64px;
        // height: 64px;
        input{
          border: 0;
          display: block;
          // flex: 1;
          width: 64px;
          height: 64px;
          background: #ffffff;
          outline: none;
          padding: 0;
          // font-size: 20px;
          font-weight: bold;
          // background: rgba(242, 244, 248, 1);
          border-radius: 0.22rem;
          text-align: center;
          transition: all ease 0.6s;
          border-radius: 12px 12px 12px 12px;
          border: 1px solid #333;
          // border: 1px solid #10a38b;
          &:last-child {
            margin-right: 0;
          }
          &:focus {
            border-color: #333;
          }
        }
        .ac{
          border: 1px solid #10a38b !important;
        }
      }
    }
  }
  ._footer {
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    background: #86909c;
    border-radius: 23px 23px 23px 23px;
    margin-bottom: 56px;
  }
  ._footer_ac{
    background:#10A38B
  }

  .el-dialog__body {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}
</style>
